<ng-container [formGroup]="formlyForm" *ngIf="recipientsLoaded$ | async">
  <form [formGroup]="formlyForm" class="desktop-recipients-form">
    <cng-mail-recipients-form #recipients [formControlName]="FormField.RECIPIENTS"></cng-mail-recipients-form>
  </form>
</ng-container>
